import { autobind } from 'core-decorators';
import { Component, Fragment } from 'react';
import Metrics from '/@/components/metrics';
import NewMetricsMobile from '/@/components/new-metrics-mobile';
import { _, _lazy } from '/@/locale';
import { isMobile } from '/@/utils';

@autobind
export default class PhytosanitaryProfile extends Component {
    static label = _lazy('Perfil Fitosanitario');
    static icon = 'fitosanitary';

    render() {
        const { brand, productRecommendations, country } = this.props;

        return (
            <Fragment>
                {!isMobile() ? (
                    <Metrics
                        dots
                        title={_('Perfil defensivo')}
                        dataKey='metrics'
                        products={productRecommendations.map((recommendation) => recommendation.profile)}
                        brand={brand}
                        country={country}
                    />
                ) : (
                    <NewMetricsMobile
                        dots
                        title={_('Perfil defensivo')}
                        country={country}
                        dataKey='metrics'
                        products={productRecommendations.map((recommendation) => recommendation.profile)}
                        brand={brand}
                    />
                )}
            </Fragment>
        );
    }
}
